export function renderBalance(amount: number, side: "Dr" | "Cr") {
  const val = Math.abs(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (side === "Cr") {
    return <span className="text-rose-600 dark:text-rose-400 font-semibold">({val})</span>;
  }
  return <span>{val}</span>;
}
